import * as Yup from "yup";

export const userValidationSchema = (isEdit = false) => {
  const passwordRegexExp = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*].*$/;

  return Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: isEdit
      ? Yup.string()
      : Yup.string()
          .min(12, "Password must be at least 12 characters long")
          .required("Password is required")
          .matches(
            passwordRegexExp,
            "Password must contain at least one number and one special character"
          ),
    passwordConfirm: isEdit
      ? Yup.string()
      : Yup.string()
          .required("Confirm Password is required")
          .min(12, "Confirm Password must be at least 12 characters long")
          .matches(
            passwordRegexExp,
            "Confirm Password must contain at least one number and one special character"
          )
          .oneOf(
            [Yup.ref("password"), null],
            "Confirm password must match with the password"
          ),
    accountArr: Yup.array().min(1, "At least one account must be selected."),
    manufacturerArr: Yup.array().min(
      1,
      "At least one manufacturer must be selected."
    ),
    role: Yup.string().required("Role is required"),
    secondary_roles: Yup.array().of(
      Yup.object().shape({
        account: Yup.string().label("Account").required(),
        roles: Yup.array()
          .label("Roles")
          .min(1, "At least one role must be selected")
          .required(),
      })
    ),
  });
};
